import { IMode } from "../@shared/lib/ModeUtils";
interface IProps {
  labelPrefix: string;
  colourModes: IMode[];
  selectedColourMode: string;
  onColourModeChanged: (colourMode: string) => void;
}

function ColourModeSelector({
  labelPrefix,
  colourModes,
  selectedColourMode,
  onColourModeChanged,
}: IProps) {
  function handleSelectChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    onColourModeChanged(e.target.value);
  }

  return (
    <tr>
      <th className="label">
        <label htmlFor="cq-pod-colour-mode">
          {labelPrefix + " "}Colour Mode <span color="red">*</span>
        </label>
        <span
          className="woo-selected-variation-item-name"
          data-default=""
        ></span>
      </th>
      <td className="value">
        <select
          id="cq-pod-colour-mode"
          className=""
          name="cq-pod-colour-mode"
          onChange={handleSelectChanged}
          value={selectedColourMode}
        >
          <option value="">Choose an option</option>
          {colourModes.map((colourMode) => (
            <option
              key={colourMode.code}
              value={colourMode.code}
              className="attached enabled"
            >
              {colourMode.name}
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
}

export default ColourModeSelector;
